<script>
	import tinycolor from "tinycolor2";
    import Tailwind from '../TailwindStyles.svelte';
	import {onMount, setContext} from "svelte";
	import {API, to} from "@API"
	import Router, {replace,push} from 'svelte-spa-router';
	import { wrap } from 'svelte-spa-router/wrap';

  import ShopHome from "@views/Home.svelte"

	// $authToken = localStorage.getItem('auth_token');
	// API.setAuthTokenStore(authToken);

	//let termsLoading = false;

  export let org;
  const organization = JSON.parse(org);

  setContext("SHOP",{
    org: organization
  })

    let cssVarStyles;

	const routes = {
      '/': ShopHome
	}


    const accentColor = tinycolor(organization.branding_primary_color);
    const overColor = tinycolor(organization.branding_primary_color);
    const overSecondaryColor = tinycolor(organization.branding_secondary_color);
    const isDark = tinycolor(organization.branding_primary_color).isDark();

    let styles = {
        'primary-color': organization.branding_primary_color,
        'secondary-color': organization.branding_secondary_color,
        'accent-color': accentColor.isLight() ? accentColor.darken(20).toHexString() : accentColor.lighten(20).toHexString(),
        'over-primary-color': overColor.isLight() ? overColor.darken(45).toHexString() : overColor.lighten(55).toHexString(),
        'over-secondary-color': overSecondaryColor.isLight() ? overSecondaryColor.darken(45).toHexString() : overSecondaryColor.lighten(55).toHexString()
    };

    $: cssVarStyles = Object.entries(styles)
        .map(([key, value]) => `--${key}:${value}`)
        .join(';');

	// onMount(async () => {
    // console.log(org);
	// });

</script>

<style>

</style>
<Tailwind/>
<div class="m-0 absolute h-full w-full" class:dark={isDark} class:light={!isDark} style="{cssVarStyles}">
    <Router {routes}/>
</div>
